// extracted by mini-css-extract-plugin
module.exports = {"searchCategories":"search-categories_searchCategories__2_uee"};